/** Менеджмент **/
import {throttle} from "./Util";
import {addEvents} from "./Popup.js";

const $popupPerson = $('.js-person');
const $departmentSelect = $('.js-department-select');
let popupSwiper;
let itemsInLine = App.W.outerWidth() < 1024 ? 2 : 3;

if ($popupPerson.length) {
    generatePopupGallery();
    addEvents($('.js-popup'));
}

if ($departmentSelect.length) {
    App.W.on('resize', throttle(function () {
        itemsInLine = App.W.outerWidth() < 1024 ? 2 : 3;
    }, 500));

    $departmentSelect.on('change', function (e) {
        const departmentType = $(this).find(':selected').val();

        if (departmentType === 'all') {
            $popupPerson.removeClass('_hidden _filtered');
        } else {
            $popupPerson.addClass('_hidden').removeClass('_filtered')
                .filter(function (index, el) {
                    let currDepartment = String($(el).data('department'));

                    if (currDepartment.indexOf(departmentType) >= 0) {
                        return $(el);
                    }
                })
                .removeClass('_hidden')
                .addClass('_filtered');
        }

        $popupPerson.removeClass('_without-margin');

        $('.js-persons-wrap').each(function () {
            $(this).find('.js-person').filter('._filtered').each(function (index, el) {
                if (index > 0 && (index + 1) % itemsInLine === 0) {
                    $(el).addClass('_without-margin');
                }
            });
        });

        e.preventDefault();
    });
}

function generatePopupSlider(slider) {
    const $container = $(slider).closest('.js-slider-wrap');
    const $prevBtn = $container.find('.js-slider-prev');
    const $nextBtn = $container.find('.js-slider-next');
    const $sliderWrapper = $container.closest('.js-popup').length ? $container.closest('.js-popup') : $container;
    const $sliderWrapperInner = $container.closest('.popup-inner').length ? $container.closest('.popup-inner') : $container;
    const $prevBtnCursor = $container.find('.js-slider-prev-cursor');
    const $nextBtnCursor = $container.find('.js-slider-next-cursor');

    // Инициализация
    popupSwiper = new Swiper(slider, {
        loop: true,
        autoHeight: App.mobilePhone,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 3
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
        threshold: 10,
        roundLengths: true,
        speed: 300,
        a11y: true,
    });

    if ($prevBtn.length) {
        $prevBtn.on('click', function () {
            popupSwiper.slidePrev();
        });
    }

    if ($nextBtn.length) {
        $nextBtn.on('click', function () {
            popupSwiper.slideNext();
        });
    }

    if ($prevBtnCursor.length && $nextBtnCursor.length) {
        const sliderEvent = App.mobile ? 'click' : 'mousemove click';

        $sliderWrapper.on(sliderEvent, throttle(function (e) {
            const userEvent = e.type;
            const left = e.pageX;
            const top = e.pageY;

            if (left > $sliderWrapperInner.offset().left && left < $sliderWrapperInner.offset().left + $sliderWrapperInner.outerWidth() * 0.3) {
                $sliderWrapper.addClass('_hover-cursor');

                if (userEvent === 'click') {
                    if (e.target.nodeName !== 'A' && e.target.nodeName !== 'a') {
                        popupSwiper.slidePrev();
                    }
                } else {
                    $prevBtnCursor.css({
                        top: `${top}px`,
                        left: `${left}px`
                    }).addClass('_visible');
                }
            } else if (left > $sliderWrapperInner.offset().left + $sliderWrapperInner.outerWidth() * 0.7) {
                $sliderWrapper.addClass('_hover-cursor');
                $prevBtnCursor.removeClass('_visible');

                if (userEvent === 'click') {
                    if (e.target.nodeName !== 'A' && e.target.nodeName !== 'a') {
                        popupSwiper.slideNext();
                    }
                } else {
                    $nextBtnCursor.css({
                        top: `${top}px`,
                        left: `${left}px`
                    }).addClass('_visible');
                }
            } else {
                disactiveHover();
            }

            if (left < $sliderWrapperInner.offset().left) {
                disactiveHover();
            }
        }, 5));

        $('.js-popup-close').on('mouseover',function () {
            setTimeout(function () {
                disactiveHover();
            }, 100);
        });
    }
}

function generatePopupGallery() {
    let popupSliderContent = '';

    $popupPerson.each(function (index, el) {
        const $currPerson = $(el);

        $currPerson.attr('data-index', index);

        popupSliderContent += `
            <figure class="slide swiper-slide">
                <div class="slide__inner">
                    <div class="slide__inner-image">
                        <div class="swiper-lazy-preloader"></div>
                        <img data-src="${$currPerson.attr('href')}" class="swiper-lazy" alt="${$currPerson.find('.js-person-name').html()}" />
                        <div class="slide__person-name">${$currPerson.find('.js-person-name').html()}</div>
                        <div class="slide__person-post">${$currPerson.find('.js-person-post').html()}</div>
                        <div class="slide__person-subdescription">${$currPerson.find('.js-person-subdescription').html()}</div>                        
                    </div>
                    <div class="slide__inner-description">${$currPerson.find('.js-person-description').html()}</div>                    
                </div>
            </figure>
        `;
    });

    let popupSlider = `
        <div class="slider-wrap popup-slider-wrap js-slider-wrap">
            <div class="slider-wrap__inner">
                <div class="slider swiper-container js-slider js-popup-slider">
                    <div class="slider__inner swiper-wrapper js-slider-inner">
                        ${popupSliderContent}
                    </div>
                </div>
            </div>
            
            <div class="slider-prev-cursor js-slider-prev-cursor"></div>
            <div class="slider-next-cursor js-slider-next-cursor"></div>
        </div>      
    `;

    App.B.append(`
        <div class="popup js-popup" data-type="popup-slider">
            <div class="popup-inner">
                <a href="#" class="popup-close js-popup-close"></a>
                ${popupSlider}    
            </div>
        </div>
    `);

    generatePopupSlider($('.js-popup-slider')[0]);

    $popupPerson.on('click', function (e) {
        const currIndex = $(this).data('index');

        popupSwiper.slideTo(currIndex, 0);
        $('.js-popup[data-type="popup-slider"]').addClass('_open');
        App.lockScroll.lock();

        e.preventDefault();
    });
}

export function disactiveHover() {
    $('._hover-cursor').removeClass('_hover-cursor');
    $('.js-slider-prev-cursor').removeClass('_visible');
    $('.js-slider-next-cursor').removeClass('_visible');
}



// WEBPACK FOOTER //
// ./_src/js/Persons.js